// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1p3Io","footer":"ChangeClinic_footer__3ia6y"};